import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

const getErrorMessage = (error: any) => {
  const errors = error?.error?.errors;
  if (Array.isArray(errors) && errors.length) {
    const message = errors
      .map((entry: any) => entry?.description || entry?.message)
      .filter(Boolean)
      .join(' ');
    if (message) {
      return message;
    }
  }
  return error?.message || 'Something went wrong.';
};

export const adminErrorToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toastController = inject(ToastController);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      const currentRoute = router.url.split('?')[0];
      const hideToastInLogin = currentRoute === '/login';

      if (!hideToastInLogin && error?.status !== 401) {
        void toastController
          .create({
            message: getErrorMessage(error),
            duration: 3000,
            position: 'bottom',
            positionAnchor: 'admin-content-card',
            color: 'danger',
            cssClass: 'moderation-toast',
          })
          .then((toast) => toast.present());
      }

      return throwError(() => error);
    }),
  );
};
